module.exports = __webpack_public_path__ + "img/ttm-main-828.7d74b5c3.jpg";